
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class DeliveryChallanBOMGrid extends Serenity.EntityGrid<DeliveryChallanBOMRow, any> {
        protected getColumnsKey() { return 'Sales.DeliveryChallanBOM'; }
        protected getDialogType() { return DeliveryChallanBOMDialog; }
        protected getIdProperty() { return DeliveryChallanBOMRow.idProperty; }
        protected getInsertPermission() { return DeliveryChallanBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return DeliveryChallanBOMRow.localTextPrefix; }
        protected getService() { return DeliveryChallanBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}